import React from "react";
import { FaEnvelope, FaInstagram, FaLinkedin } from "react-icons/fa"; // Importando ícones
import { useLanguage } from "../LanguageContext";
import translations from "../translations";

const Footer = () => {

  const { language } = useLanguage();

  return (
    <footer className="bg-gray-800 text-white text-center p-10 mt-10">
      <div className="flex flex-col lg:flex-row justify-center items-center space-y-4 lg:space-y-0 lg:space-x-8">
        <div className="flex items-center space-x-3">
          <FaEnvelope className="text-blue-400 text-3xl" />
          <p>
            <span className="font-semibold">Email:</span>{" "}
            <a
              href="mailto:marceloatj@hotmail.com"
              className="text-blue-300 hover:text-blue-500 transition duration-300"
            >
              marceloatj@hotmail.com
            </a>
          </p>
        </div>
        <div className="flex items-center space-x-3">
          <FaInstagram className="text-pink-500 text-3xl" />
          <p>
            <span className="font-semibold">Instagram:</span>{" "}
            <a
              href="https://instagram.com/marceloatj"
              className="text-blue-300 hover:text-pink-500 transition duration-300"
            >
              @marceloatj
            </a>
          </p>
        </div>
        <div className="flex items-center space-x-3">
          <FaLinkedin className="text-blue-700 text-3xl" />
          <p>
            <span className="font-semibold">LinkedIn:</span>{" "}
            <a
              href="https://www.linkedin.com/in/marceloatj"
              className="text-blue-300 hover:text-blue-500 transition duration-300"
            >
              linkedin.com/in/marceloatj
            </a>
          </p>
        </div>
      </div>
      <p className="mt-6">&copy; {new Date().getFullYear()} {translations[language].footerMessage}</p>
    </footer>
  );
};

export default Footer;
